import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAboutSite, getAboutPhoto } from "../../store/about/aboutAction";
import { baseUrl } from "../../utils/APi";
import Loader from "../../component/Loader";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation,Pagination } from "swiper/modules";
import aboutImg from "../../assets/gal2.jpg";
import Bread from "../../component/Bread";
const About = () => {
  // const { t } = useTranslation();
  // const dispatch = useDispatch();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { aboutSite, aboutPhoto, loading } = useSelector(
  //   (state) => state.aboutSlicer
  // );
  // const stripHtmlTags = (html) => {
  //   const doc = new DOMParser().parseFromString(html, "text/html");
  //   return doc.body.textContent || "";
  // };
  // const aboutSiteText = stripHtmlTags(aboutSite ? aboutSite :"");
  // useEffect(() => {
  //   dispatch(getAboutSite(lan));
  //   dispatch(getAboutPhoto());
  // }, [dispatch, lan]);
  const testimonials = [
    {
      text: "I’m amazed, I should say thank you so much for your awesome work. The design is so good and neat, every detail has been taken care of. This team is really amazing and talented!",
      author: "Sara Simpson",
      company: "Google"
    },
    {
      text: "I’m amazed, I should say thank you so much for your awesome work. The design is so good and neat, every detail has been taken care of. This team is really amazing and talented! I will work only with Enigma agency.",
      author: "John C. Marshall",
      company: "Apple"
    },
    {
      text: "I’m amazed, I should say thank you so much for your awesome work. The design is so good and neat, every detail has been taken care of. This team is really amazing and talented! I will work only with Enigma agency.",
      author: "Clint Eastwood",
      company: "Amazon"
    }
  ];
  return  (
    <Fragment>
      <Bread title={"Home"} span={"About"} />


      <section className="section-wrap about-us pb-60">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <img src={aboutImg} alt="" />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-8">
            <h4 className="about-intro uppercase">about our shop</h4>
            <p>security Shop is a very slick and clean e-commerce  with endless possibilities. Creating an awesome clothes store with this Theme is easy than you can imagine. And finally the subconscious is the mechanism through which thought impulses which are repeated regularly with feeling. And emotion are quickened. security Shop is a very slick and clean e-commerce  with endless possibilities. security Shop is a very slick and clean e-commerce  with endless possibilities.</p>
          </div>
          <div className="col-sm-3 col-sm-offset-1">
            <div className="statistic">
              <span>1999</span>
              <h4 className="uppercase">year of foundation</h4>
            </div>            
            <div className="statistic">
              <span>120</span>
              <h4 className="uppercase">partners work with us</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section-wrap testimonials">
      <div className="container">

        <div className="row heading-row mb-60">
          <div className="col-md-12 text-center">
            <h2 className="heading uppercase">Happy Clients</h2>
          </div>
        </div>

        <Swiper
          spaceBetween={30}
          pagination={{ clickable: true }}
          modules={[Pagination]}
          className="owl-carousel owl-theme owl-dark-dots text-center"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial">
                <p className="testimonial-text">{testimonial.text}</p>
                <span className="uppercase">{`${testimonial.author} / ${testimonial.company}`}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>

    </Fragment>
  );
};

export default About;
